import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-05dfe1f9")

_pushScopeId("data-v-05dfe1f9")
const _hoisted_1 = {
  key: 0,
  class: "grid gap-y-6",
  style: {"width":"582px"}
}
const _hoisted_2 = {
  class: "grid gap-y-6",
  style: {"width":"582px"}
}
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "flex-grow pr-3" }
const _hoisted_5 = { class: "py-1.5" }
const _hoisted_6 = {
  key: 0,
  class: "flex mt-6 mb-1.5 items-center"
}
const _hoisted_7 = { class: "text-20px font-semibold text-black-lp-300 uppercase" }
const _hoisted_8 = { class: "flex justify-end mt-10" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_error_message = _resolveComponent("error-message")!
  const _component_select_search = _resolveComponent("select-search")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modelValue: _ctx.showAddBank,
    persistent: true,
    title: `${_ctx.$t('Tambah Rekening Bank')}`,
    class: "add-bank",
    "onUpdate:modelValue": _cache[4] || (_cache[4] = 
      () => {
        _ctx.onShowAddBank(false);
      }
    )
  }, {
    default: _withId(() => [
      (_ctx.isErrorValidationBank && _ctx.errorCauseValidationBank !== 'client')
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _createVNode(_component_error_message, {
              errorType: _ctx.errorCauseValidationBank,
              onTryAgain: _ctx.onValidateBank
            }, null, 8, ["errorType", "onTryAgain"])
          ]))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('partnerManagement.bank'),
                asterisk: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_select_search, {
                    placeholder: _ctx.$t('partnerManagement.chooseBank'),
                    modelValue: _ctx.form.bank.bankName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.bank.bankName = $event)),
                    options: _ctx.bankList,
                    "key-name": "name",
                    "key-value": "value",
                    "server-side": false,
                    "is-loading": _ctx.loadingBank,
                    onFocus: _ctx.fetchListBank,
                    class: "w-full my-2 z-10",
                    onChange: _ctx.resetBank
                  }, null, 8, ["placeholder", "modelValue", "options", "is-loading", "onFocus", "onChange"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('partnerManagement.accNo'),
                asterisk: ""
              }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_3, [
                    _createVNode("div", _hoisted_4, [
                      _createVNode(_component_lp_input, {
                        modelValue: _ctx.form.bank.accountNo,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.bank.accountNo = $event)),
                        placeholder: _ctx.isDisabled ? '' : _ctx.$t('partnerManagement.inputAccount'),
                        error: _ctx.isErrorValidationBank,
                        onChange: _ctx.validateAccountNo,
                        errorCaption: _ctx.error.accountBankNoMessage,
                        disabled: _ctx.isDisabled,
                        disableBackground: _ctx.isDisabled,
                        format: _ctx.formatNumber
                      }, null, 8, ["modelValue", "placeholder", "error", "onChange", "errorCaption", "disabled", "disableBackground", "format"])
                    ]),
                    _createVNode("div", _hoisted_5, [
                      _createVNode(_component_button_fill, {
                        onClick: _ctx.onValidateBank,
                        title: _ctx.$t('partnerManagement.check'),
                        class: "bg-red-lp-300 px-8",
                        style: {"width":"117px"},
                        isLoading: _ctx.isLoadingValidationBank,
                        isDisabled: _ctx.isDisabledValidate
                      }, null, 8, ["onClick", "title", "isLoading", "isDisabled"])
                    ])
                  ]),
                  (_ctx.form.bank.accountName)
                    ? (_openBlock(), _createBlock("div", _hoisted_6, [
                        _createVNode("img", {
                          src: require('@/app/ui/assets/svg/bank-red.svg'),
                          class: "mr-3",
                          style: {"width":"42px"},
                          alt: "bank"
                        }, null, 8, ["src"]),
                        _createVNode("span", _hoisted_7, _toDisplayString(_ctx.maskedBankAccountName), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_DataWrapper, {
                label: "Email",
                optional: ""
              }, {
                default: _withId(() => [
                  _createVNode(_component_lp_input, {
                    modelValue: _ctx.form.bank.accountEmail,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.bank.accountEmail = $event)),
                    placeholder: _ctx.isDisabled ? '' : 'e.g email@gmail.com',
                    onChange: _ctx.validateEmailBank,
                    errorCaption: _ctx.$t('partnerManagement.list.enterEmailError'),
                    error: _ctx.error.bankEmail,
                    disabled: _ctx.isDisabled,
                    disableBackground: _ctx.isDisabled
                  }, null, 8, ["modelValue", "placeholder", "onChange", "errorCaption", "error", "disabled", "disableBackground"])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_8, [
              _createVNode(_component_button_fill, {
                onClick: _ctx.onAddBank,
                title: _ctx.$t('Simpan'),
                class: "bg-red-lp-300 px-8",
                style: {"width":"164px"},
                isDisabled: _ctx.isDisabledSave
              }, null, 8, ["onClick", "title", "isDisabled"])
            ])
          ], 64))
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
})